import { render, staticRenderFns } from "./HospitalIntroSdzyy.vue?vue&type=template&id=5f132695&scoped=true"
import script from "./HospitalIntroSdzyy.vue?vue&type=script&lang=js"
export * from "./HospitalIntroSdzyy.vue?vue&type=script&lang=js"
import style0 from "./HospitalIntroSdzyy.vue?vue&type=style&index=0&id=5f132695&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f132695",
  null
  
)

export default component.exports